/** sessionStorage key set when user leaves Add Property to configure payment channels */
export const SETTINGS_RETURN_ADD_PROPERTY_KEY = 'tenantplus:settingsReturn:add-property';

/** Dispatched after a channel is saved so Properties can reopen Add Property drawer */
export const RESUME_ADD_PROPERTY_EVENT = 'tenantplus:resume-add-property';

export function markSettingsReturnToAddProperty(): void {
  try {
    sessionStorage.setItem(SETTINGS_RETURN_ADD_PROPERTY_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function consumeSettingsReturnToAddProperty(): boolean {
  try {
    const pending = sessionStorage.getItem(SETTINGS_RETURN_ADD_PROPERTY_KEY);
    if (pending) {
      sessionStorage.removeItem(SETTINGS_RETURN_ADD_PROPERTY_KEY);
      return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}

export function dispatchResumeAddProperty(): void {
  window.dispatchEvent(new CustomEvent(RESUME_ADD_PROPERTY_EVENT));
}
